import React from 'react'

// We use this to detect whether or not a component is syndicated
export const SyndicationContext = React.createContext<null | boolean>(null)
